import React from 'react';

import Select from '~/components/forms/Select';
import DateInput from '~/components/forms/DateInput';

/**
 * PROPS
 * filters = array of objects
 * onChange(filterName, value) = func
 */

const PlaybillFilter = props => {
  const filters = props.filters.map(f => {
    switch (f.type) {
      case 'tags':
        return null; // see below
      case 'select':
        if (f.name == 'online') return null;
        return (
          <Select
            key={f.name}
            isMulti={f.isMulti}
            label={f.label}
            value={f.value ? f.value : ''}
            options={f.options}
            onChange={val => props.onChange(f.name, val)}
          />
        );
      case 'date':
        return (
          <DateInput
            key={f.name}
            label={f.label}
            value={f.value ? f.value : new Date()}
            options={f.options}
            onChange={val => props.onChange(f.name, val)}
          />
        );
      default:
        return null;
    }
  });

  // Custom tags for online/not-online events
  const filterOnline = props.filters.filter(f => f.name == 'online').pop();
  const tags = filterOnline.options.map(o => {
    const classes = ['tag'];
    if (filterOnline.value.includes(o.value)) classes.push('tag--selected');
    return (
      <button
        key={o.value}
        className={classes.join(' ')}
        onClick={() => props.onChange(filterOnline.name, o.value)}
      >
        {o.label}
      </button>
    );
  });

  const onlineTags = (
    <div className="tags tags--grey tags--sm">
      {tags}
    </div>
  );

  return (
    <section className="section section--schedule-filter">
      <div className="container">
        <div className="row"></div>
        {onlineTags}
        <div className="select-wrap select-wrap--row">{filters}</div>
      </div>
    </section>
  );
};

export default PlaybillFilter;
